import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import InclusionItem from 'components/Common/InclusionItem'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { INCLUSIONS_TITLE_BONUS } from 'constants/inclusions'

const Stack = styled.div`
  & > * + * {
    margin-top: ${rem(8)}
  }

  &.md {
    & > * + * {
      margin-top: ${rem(12)}
    }
  }
`

interface Props {
  inclusions: Array<App.PackageInclusionV2>;
}

export function HotelSummaryInclusionsV2({ inclusions }: Props) {
  const bonusInclusions = inclusions.filter(inclusion => inclusion && inclusion.style === 'bonus')
  const regularInclusions = inclusions.filter(inclusion => inclusion && inclusion.style !== 'bonus')

  return (
    <Stack className="md">
      {regularInclusions && regularInclusions.length > 0 && (
        <div>
          <BodyText variant="medium" weight="bold">Package inclusions:</BodyText>
          {regularInclusions.map(({ inclusion, style }) => <InclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted={style === 'highlighted'} />)}
        </div>
      )}
      {bonusInclusions && bonusInclusions.length > 0 && (
        <div>
          <BodyText variant="medium" weight="bold" format="propercase">{INCLUSIONS_TITLE_BONUS}:</BodyText>
          {bonusInclusions.map(({ inclusion }) => <InclusionItem key={inclusion.id} inclusion={inclusion} />)}
        </div>
      )}
    </Stack>
  )
}
